import axiosInstance from 'api/axiosInstance';

export const extractLicensePlate = async (
	base64Image: string,
): Promise<{
	LicensePlate: string;
	LicenseState: string;
}> => {
	try {
		const API_URL = `/api2.0/tickets/extractLicensePlate`;
		const response = await axiosInstance.post(
			API_URL,
			{
				imageData: base64Image,
			},
			{
				headers: {
					'Content-Type': 'application/json',
				},
			},
		);
		console.log('response from extractLicensePlate', response.data);

		return response.data;
	} catch (error) {
		console.error('Error adding ticket:', error);
		throw error;
	}
};
